import {
  type PropsWithChildren,
  type MouseEvent as ReactMouseEvent,
} from 'react';

import { InteractiveChartTooltip } from '../../../../core/components/tooltip/InteractiveChartTooltip/components/InteractiveChartTooltip.js';
import { useSeriesBasedItemEstimatedSize } from '../../../../core/components/tooltip/InteractiveChartTooltip/hooks/useSeriesBasedItemEstimatedSize.js';
import { TooltipItem } from '../../../../core/types/tooltip.js';
import { useExploreState } from '../../../hooks/store/selectors.js';
import { ADJUSTED_LAYOUT_OFFSET } from '../constants.js';

interface HistogramTooltipWrapperProps {
  tooltipItems: TooltipItem[];
  onMouseLeave: (event?: ReactMouseEvent) => void;
  onScrollContent: (event?: Event) => void;
}

export const HistogramTooltipWrapper = ({
  tooltipItems,
  onMouseLeave,
  onScrollContent,
  children,
}: PropsWithChildren<HistogramTooltipWrapperProps>) => {
  const { pinned, position } = useExploreState();

  const estimatedItemSize = useSeriesBasedItemEstimatedSize(
    tooltipItems,
    'single-line',
  );

  const adjustedTooltipPosition = position?.absolute
    ? {
        x: position.absolute.x + ADJUSTED_LAYOUT_OFFSET.x,
        y: position.absolute.y + ADJUSTED_LAYOUT_OFFSET.y,
      }
    : undefined;

  const showTooltip = tooltipItems.length && adjustedTooltipPosition;

  return showTooltip ? (
    <InteractiveChartTooltip
      position={adjustedTooltipPosition}
      pinned={pinned}
      itemSize={estimatedItemSize}
      onMouseLeave={onMouseLeave}
      onScrollContent={onScrollContent}
    >
      {children}
    </InteractiveChartTooltip>
  ) : null;
};
